import { REF_VALUE } from 'src/constants'

// routes
export const COMPANY_REFERENCE_GET_POST = '/company/reference-table'
export const COMPANY_REFERENCE_PATCH = '/company/:refUuid/reference-table'
export const COMPANY_REFERENCE_ORDER_PATCH =
  '/company/reference-table-order-group'

// sorting
export const COMPANY_REFERENCE_DEFAULT_SORT = {
  sortedColumn: REF_VALUE,
  sortedColumnOrder: 'ascend'
}

export const REFERENCE_TABLE_PAGE_SIZE = 10000
